import React, { MouseEvent } from "react";
import { MaterialDesignIcons } from "../styled";

export const SpellCheckMIcon: React.FC<{
  fontSize?: string;
  onClick?: (e: MouseEvent<HTMLDivElement>) => void;
}> = ({ fontSize, onClick }) => {
  return (
    <MaterialDesignIcons fontSize={fontSize} onClick={onClick}>
      spellcheck
    </MaterialDesignIcons>
  );
};
